<template>
  <div class="trainer-trainstats trainstats hvc">
    <div class="trainstats_items">
      <div class="trainstats_hands">
        <div class="trainstats_big_num trainstats_hands_item">
          <div
            class="trainstats_big_title csst csst_nm"
            @mouseenter="fl_positionTooltip"
          >
            {{ $t('common.hands') }}
            <div
              class="csst_content clr-white"
              style="position: fixed"
            >
              {{ $t(`tooltips.trainer_stats_hands`) }}
            </div>
          </div>
          <div class="d-flex">
            {{ numKtoM(l_stats.total_hands.value, 10000, 2) }}
          </div>
        </div>
        <div class="trainstats_big_num trainstats_hands_item">
          <div
            class="trainstats_big_title csst csst_nm"
            @mouseenter="fl_positionTooltip"
          >
            {{ $t('common.moves') }}
            <div
              class="csst_content clr-white"
              style="position: fixed"
            >
              {{ $t(`tooltips.trainer_stats_moves`) }}
            </div>
          </div>
          <div class="d-flex">
            {{ numKtoM(l_stats.total_moves.value, 10000, 2) }}
          </div>
        </div>
        <div class="trainstats_big_num trainstats_hands_item">
          <div class="trainstats_big_title">
            {{ $t('common.gto_score') }}
          </div>
          <div class="d-flex">
            <!-- {{ numFixed(l_stats.avg_gto_score.value * 100) }} -->
            {{ numFixed(l_stats.gto_score_per_hand.value * 100) }}
            <span class="trainstats_big_num_unit"> % </span>
          </div>
        </div>
      </div>

      <div class="trainstats_moves_charts">
        <div class="trainstats_moves_move">
          <i class="mdi text-semi-large mr-1 mdi-check clr-primary" />
          <div class="trainstats_moves_move_num">
            {{ numKtoM(l_stats.total_good_res.value, 10000) }}
          </div>
          <div class="trainstats_chart">
            <div
              class="trainstats_chart_column clr-primary"
              :style="`width:${
                (l_stats.total_good_res.value / (l_stats.total_moves.value || 1)) * 100
              }%`"
            ></div>
          </div>
        </div>
        <div class="trainstats_moves_move">
          <i class="mdi text-semi-large mr-1 mdi-alert-circle-outline clr-error" />
          <div class="trainstats_moves_move_num">
            {{ numKtoM(l_stats.total_bad_res.value, 10000) }}
          </div>
          <div class="trainstats_chart">
            <div
              class="trainstats_chart_column clr-error"
              :style="`width:${
                (l_stats.total_bad_res.value / (l_stats.total_moves.value || 1)) * 100
              }%`"
            ></div>
          </div>
        </div>
      </div>

      <div class="trainstats_moves">
        <div
          v-for="item in [
            'best_moves',
            'correct_moves',
            'inaccuracy_moves',
            'wrong_moves',
            'blunder_moves',
          ]"
          :key="item"
          class="trainstats_moves_move csst csst_nm"
          @mouseenter="fl_positionTooltip"
        >
          <!-- :style="`--anim-duration:${iIdx * 0.15}s;`" -->
          <i
            class="mdi text-semi-large mr-1"
            :class="l_stats[item].group.icon"
            :style="`color: var(${l_stats[item].group.color})`"
          />
          <div class="trainstats_moves_move_num">
            {{ numKtoM(l_stats[item].value, 10000) }}
          </div>
          <div class="trainstats_moves_move_title">
            {{ l_stats[item].name }}
          </div>
          <div
            class="csst_content clr-white"
            style="position: fixed; min-width: 14rem; max-width: 26rem"
          >
            {{ $t(`tooltips.${item}`) }}
          </div>
        </div>
      </div>

      <div class="trainstats_ev">
        <!-- class="trainstats_ev_item anim-fade-in-timed" -->
        <div
          v-for="item in mistakes"
          :key="item.id"
          class="trainstats_ev_item"
        >
          <!-- 'average_ev_mistake' -->
          <!-- :style="`--anim-duration:${iIdx * 0.3 + 0.6}s;`" -->
          <div
            class="trainstats_big_title csst csst_nm"
            @mouseenter="fl_positionTooltip"
          >
            {{ item.name }}
            <div
              class="csst_content clr-white"
              style="position: fixed"
            >
              {{ item.tooltip }}
            </div>
          </div>
          <div class="trainstats_big_num">
            {{ item.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import { getCorrectnessActionGroups } from '@/helpers/constants'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'TrainerStats',
  mixins: [format_mix, float_mix],
  props: {
    stats: Object,
  },
  data() {
    return {}
  },
  methods: {
    // reset() {
    //   this.$store.dispatch('stats_stats_reset')
    // },
  },
  computed: {
    l_stats() {
      let res = []
      const {stats} = this
      const groups = getCorrectnessActionGroups()
      const rows = [
        { key: 'total_hands', unit: '', name: this.$t(`practice.stats.hands`) },

        { key: 'total_moves', unit: '', name: this.$t('common.moves') },
        { key: 'played_hands', unit: '' },
        { key: 'total_good_res', unit: '' },
        { key: 'total_bad_res', unit: '' },
        { key: 'good_percentage', unit: '%', fn: val => val * 100 },
        { key: 'avg_gto_score', name: this.$t(`common.gto_score`), unit: '' },
        { key: 'gto_score_per_hand', name: this.$t(`common.gto_score`), unit: '' },

        { key: 'total_ev_loss', unit: '' },
        { key: 'average_ev_mistake', unit: '' },
        { key: 'average_ev_loss', unit: '' },

        // { key: 'inaccuracy_moves', unit: '', group: groups.inaccuracy },
        {
          key: 'inaccuracy_moves',
          name: this.$t(`practice.stats.inaccuracy`),
          unit: '',
          group: groups.inaccuracy,
        },
        { key: 'best_moves', unit: '', group: groups.best_move },
        { key: 'correct_moves', unit: '', group: groups.correct_move },
        { key: 'wrong_moves', unit: '', group: groups.wrong_move },
        { key: 'blunder_moves', unit: '', group: groups.blunder },
      ]
      res = rows.map(dd => ({
        ...dd,
        name: dd.name ? dd.name : this.$t(`practice.stats.${dd.key}`),
        value: stats[dd.key] || 0,
      }))

      const objRes = {}
      res.forEach(i => {
        objRes[i.key] = i
      })
      // console.log(res, this.stats)
      return objRes
    },
    mistakes() {
      let res = [
        {
          id: 'total_ev_loss',
          // unit: this.$t('common.bb'),
          decimal: 2,
        },
        {
          id: 'average_ev_loss',
          // unit: this.$t('common.bb'),
          decimal: 2,
        },
        //  {
        //   id: 'average_ev_mistake',
        //       // unit: this.$t('common.bb'),
        //       decimal: 1,
        // },
      ]
      res = res.map(i => {
        const r = {
          name: this.$t(`practice.stats.${i.id}`),
          tooltip: this.$t(`tooltips.${i.id}`),
          value: this.numFixed(this.stats[i.id], i.decimal),
        }
        return r
      })
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.csst_content {
  min-width: 10rem;
}
.locale_de {
  .trainstats_ev {
    word-break: break-all;
  }
}
.trainstats {
  --grid-gap: 1rem;
  --grid-gap-big-num: 1rem;
  display: flex;
  flex-direction: column;
  cursor: default;

  &_items {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    grid-gap: var(--grid-gap);
  }
  &_ev,
  &_hands {
    display: flex;
    width: 100%;
    word-wrap: break-word;
    grid-gap: var(--grid-gap-big-num);
  }
  &_chart {
    display: flex;
    flex: 1;
    align-items: flex-end;
    --chart-height: var(--height-chart-small);
    height: var(--chart-height);
    background: var(--clr-black-3);
    // border-radius: 99px;
    border-radius: 4px;
    overflow: hidden;
    &_column {
      height: 100%;
      min-width: 2px;
      // border-radius: 99px;
      border-radius: 4px;
      background: currentColor;
      position: relative;
      display: flex;
      justify-content: center;
      min-height: 2px;
      transition: 0.2s;
      &_legend {
        font-size: 0.8rem;
        font-weight: 700;
        position: absolute;
        top: -1.25rem;
      }
    }
  }
  &_moves {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    &_move {
      display: flex;
      grid-gap: 0.25rem;
      align-items: center;
      line-height: 1.2;
      &_num {
        font-weight: 700;
        min-width: 3rem;
        margin-left: 0.25rem;
      }
      &_title {
        font-weight: 500;
        width: 100%;
        position: relative;
      }
    }
  }
  &_big {
    &_container {
      display: flex;
      grid-gap: 1rem;
    }
    &_num {
      font-size: 1.75rem;
      font-weight: 700;
      line-height: 1;
      &_icon {
        font-size: 1.75rem;
        margin-right: 0.25rem;
        &_svg {
          margin-right: 0.25rem;

          fill: currentColor;
          width: 1.75rem;
        }
      }
    }
    &_title {
      font-size: 0.875rem;
      font-weight: 500;
      line-height: 1.1;
      overflow-wrap: break-word;
      color: var(--clr-grey-2);
      // text-transform: uppercase;
      margin-bottom: 0.5rem;
    }
  }
  &_medium {
    &_title {
      font-size: 0.8rem;
      font-weight: 400;
    }
    &_num {
      font-weight: 700;
      line-height: 1;
      display: flex;
      align-items: center;
    }
  }
}
</style>
